import React from 'react';
import ImageGallery from 'react-image-gallery';
import { getDayjs, getImageSize } from '../utils';
import loadable from '@loadable/component';
import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

import '../css/ProductVideo.less';
import 'react-image-gallery/styles/css/image-gallery.css';

const ReactPlayer = loadable(() => import('react-player/youtube'));

export default class ProductVideo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            video: true,
            showFullscreenButton: true,
            showGalleryFullscreenButton: true,
            showVideo: {},
            images: this.props.images == null ? [] : this.props.images,
            videos: this.props.videos,
            interactiveGallery: this.props.interactiveGallery,
            manufacturer: this.props.manufacturer,
            product: this.props.product,
        };

        // detect enter or exit fullscreen mode
        document.addEventListener('webkitfullscreenchange', this.fullscreenChange, {
            passive: true,
        });
        document.addEventListener('mozfullscreenchange', this.fullscreenChange, { passive: true });
        document.addEventListener('fullscreenchange', this.fullscreenChange, { passive: true });
        document.addEventListener('MSFullscreenChange', this.fullscreenChange, { passive: true });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.manufacturer !== this.state.manufacturer) {
            this.setState({ manufacturer: this.props.manufacturer });
        }
    }
    _onSlide = (index) => {
        this._resetVideo();
    };

    _handleThumbnailPositionChange(event) {
        this.setState({ thumbnailPosition: event.target.value });
    }

    _resetVideo = () => {
        this.setState({ showVideo: {} });

        if (this.state.showFullscreenButton) {
            this.setState({ showGalleryFullscreenButton: true });
        }
    };

    _toggleShowVideo = (url) => {
        let showVideo = this.state.showVideo;
        showVideo[url] = !Boolean(this.state.showVideo[url]);
        this.setState({
            showVideo: showVideo,
        });

        if (this.state.showVideo[url]) {
            if (this.state.showFullscreenButton) {
                this.setState({ showGalleryFullscreenButton: false });
            }
        }
    };

    _renderVideo = (item) => {
        return (
            <div className="image-gallery-image">
                {this.state.showVideo[item.embedUrl] ? (
                    <div className="video-wrapper">
                        <div className="player-wrapper-new">
                            <ReactPlayer
                                className="react-player-new"
                                url={item.embedUrl}
                                config={{
                                    youtube: {
                                        embedOptions: {
                                            host: 'https://www.youtube-nocookie.com',
                                        },
                                        playerVars: {
                                            hl: 'is',
                                            modestbranding: '1',
                                        },
                                    },
                                }}
                                playing
                                width="100%"
                                height="100%"
                                controls
                            />
                        </div>
                    </div>
                ) : (
                    <div onClick={() => this._toggleShowVideo(item.embedUrl)}>
                        <div className="play-button" />
                        <img alt={'video'} src={item.original} />
                        {item.description && (
                            <span
                                className="image-gallery-description"
                                style={{ right: '0', left: 'initial' }}
                            >
                                {item.description}
                            </span>
                        )}
                    </div>
                )}
            </div>
        );
    };

    myRenderThumbInner = (item) => {
        return (
            <span className="image-gallery-thumbnail-inner">
                <div className="play-button-thumbnail"></div>
                <img
                    class="image-gallery-thumbnail-image"
                    src={item.thumbnail}
                    alt={item.thumbnailAlt}
                    title={item.thumbnailTitle}
                />
                {item.thumbnailLabel && (
                    <div className="image-gallery-thumbnail-label">{item.thumbnailLabel}</div>
                )}
            </span>
        );
    };

    compareImageNames(a, b) {
        let regex = /_(\d+)+_/;
        let imgStringA = a.match(regex);
        let imgStringB = b.match(regex);
        let imgNumberA = parseInt(imgStringA[1]);
        let imgNumberB = parseInt(imgStringB[1]);
        if (imgNumberA < imgNumberB) {
            return -1;
        }
        if (imgNumberA > imgNumberB) {
            return 1;
        }
        // a must be equal to b
        return 0;
    }

    iframeFullscreen() {
        // check if fullscreen mode is available
        if (
            document.fullscreenEnabled ||
            document.webkitFullscreenEnabled ||
            document.mozFullScreenEnabled ||
            document.msFullscreenEnabled
        ) {
            //$('#product-iframe').toggleClass('hidden');
            // which element will be fullscreen
            var iframe = document.querySelector('#product-iframe');
            // Do fullscreen
            if (iframe.requestFullscreen) {
                iframe.requestFullscreen();
            } else if (iframe.webkitRequestFullscreen) {
                iframe.webkitRequestFullscreen();
            } else if (iframe.mozRequestFullScreen) {
                iframe.mozRequestFullScreen();
            } else if (iframe.msRequestFullscreen) {
                iframe.msRequestFullscreen();
            }
        } else {
            document.querySelector('.error').innerHTML = 'Your browser is not supported';
        }
    }
    fullscreenChange() {
        // force to reload iframe once to prevent the iframe source didn't care about trying to resize the window
        // comment this line and you will see
        //var iframe = document.querySelector('iframe');
        //iframe.src = iframe.src;
    }

    getFeaturedCorner = () => {
        const dateCorner = this.getFormattedDateAvailable();
        if (dateCorner !== null) return dateCorner;
        else if (this.state.product.syningareintok > 0) return this.getSyningarEintakBanner();
    };

    getFormattedDateAvailable = () => {
        const product = this.state.product;
        const showDateAvailable =
            !product.disabled && product.expected && product.quantity <= 0 && product.dateAvailable;
        if (!showDateAvailable || !this.props.displayDateAvailable) return null;
        return (
            <div id="date-available-corner" className="featured-corner">
                <Tooltip title="Aðeins til viðmiðunar, getur breyst án fyrirvara">
                    <span>
                        <b>Vara væntanleg</b> <br />
                        {getDayjs(product.dateAvailable).format('D. MMMM').toLowerCase()} <br />
                        <InfoCircleFilled />
                    </span>
                </Tooltip>
            </div>
        );
    };

    getSyningarEintakBanner = () => {
        return (
            <div id="syningareintak-corner" className="featured-corner">
                <span>Varan er til sýnis í Borgartúni 37</span>
            </div>
        );
    };

    getManufacturerImage = () => {
        const imagePath = this.state.manufacturer.image;
        if (!imagePath || !imagePath.trim()) return null;
        const image = (
            <img
                alt={'Vörumerki'}
                className={'manufacturer-image'}
                src={window.imageBase + '/' + imagePath.trim()}
            />
        );
        return (
            <a href={'/ShowProductsForManufacturer?manuId=' + this.state.manufacturer.id}>
                {image}
            </a>
        );
    };

    render() {
        const stockImage = [
            {
                original: '/images/netverslun/myndvantar.jpg',
                thumbnail: '/images/netverslun/myndvantar.jpg',
            },
        ];

        let images = [];

        let smallImages = getImageSize(this.state.images, 'medium');
        let bigImages = getImageSize(this.state.images, 'big');

        smallImages = smallImages.sort(this.compareImageNames);
        bigImages = bigImages.sort(this.compareImageNames);

        for (let i = 0; i < smallImages.length; i++) {
            images.push({
                original: '/images' + bigImages[i],
                thumbnail: '/images' + smallImages[i],
                srcSet: '/images' + bigImages[i] + ' 1000w, /images' + smallImages[i] + ' 400w',
                sizes: '(max-width: 500px) 400px, 100vw',
                originalAlt: this.state.product.name + '-' + i,
                thumbnailAlt: this.state.product.name + '-thumbnail' + i,
                originalTitle: this.state.product.name + '-' + i,
                thumbnailTitle: this.state.product.name + '-thumbnail' + i,
            });
        }
        if (this.state.videos) {
            let videoArr = this.state.videos.split(';');
            for (let i = 0; i < videoArr.length; i++) {
                let video = videoArr[i];
                if (video) {
                    if (video.includes('/')) {
                        video = video.substring(video.lastIndexOf('/') + 1, video.length);
                    }
                    images.push({
                        original: 'https://img.youtube.com/vi/' + video + '/hqdefault.jpg',
                        thumbnail: 'https://img.youtube.com/vi/' + video + '/hqdefault.jpg',
                        embedUrl: 'https://www.youtube.com/watch?v=' + video,
                        renderItem: this._renderVideo,
                        renderThumbInner: this.myRenderThumbInner,
                    });
                }
            }
        }
        let imagesPresent = images.length > 0;
        return (
            <div className="videoplayer">
                {this.getFeaturedCorner()}
                {this.state.manufacturer && this.getManufacturerImage()}
                <div className="video-container">
                    <ImageGallery
                        items={imagesPresent ? images : stockImage}
                        showBullets={
                            this.state.showFullscreenButton &&
                            this.state.showGalleryFullscreenButton
                        }
                        showPlayButton={false}
                        additionalClass="app-image-gallery"
                        onSlide={this._onSlide}
                        showFullscreenButton={
                            this.state.showFullscreenButton &&
                            this.state.showGalleryFullscreenButton
                        }
                        lazyLoad={true}
                        showThumbnails={imagesPresent}
                    />
                </div>
                {this.props.interactiveGallery ? (
                    <div className={'interactive-gallery'}>
                        <div
                            className={'interactive-gallery-button'}
                            onClick={this.iframeFullscreen}
                        >
                            <img
                                alt={'Skoða 3D myndir'}
                                src={window.imageBase + '/fullscreen.png'}
                            />
                            <span>Skoða 3D myndir</span>
                        </div>
                        <iframe
                            title={'3D-gallery'}
                            id="product-iframe"
                            src={this.props.interactiveGallery}
                            scrolling="no"
                            frameBorder="0"
                            width="100%"
                            height="0"
                            allowFullScreen
                        />
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}
